<template lang="html">
  <div class="cover-popup row-center" v-if="encuestas">
    <div class="popup">
      <h2 class="title-pop">{{ $t("popup_encuestas_obligatorias.titulo") }}</h2>
      <p>{{ $t("popup_encuestas_obligatorias.subtitulo") }}</p>
      <p>
        <arrow-link
          v-for="(encuesta, key) in encuestas"
          class="arrow-link"
          :key="key"
          :text="encuesta.titulo"
          :to="$t('enlaces.encuestas') + '/' + encuesta.urlAcceso"
        ></arrow-link>
      </p>
    </div>
  </div>
</template>

<script lang="js">

import { mapGetters, mapActions } from 'vuex';
import router from '@/router'
import arrowLink from '@/components/parts/icons/arrow-link';
export default {
  name: 'popup-pedir-NAF',
  props: ['encuestas'],
  data() {
    return {
    }
  },
   components: {
    'arrow-link': arrowLink
  },
  computed: {
    ...mapGetters({
      brand: 'getBrand',
      style: 'getStyles'
    })
  },
  methods: {

  }
}
</script>
<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/components/parts/popup-encuestas-obligatorias.vue